import Rails from 'rails-ujs'
import Flickity from 'flickity'
import Flash from './Flash'
import 'flickity-as-nav-for'

export const sidebarSlider = {
  container: document.querySelector('.js-sidebar-slider'),
  prevButton: document.querySelector('.js-sidebar-prev'),
  nextButton: document.querySelector('.js-sidebar-next'),
  steps: document.querySelectorAll('.js-sidebar-step'),
  slider: null,
  form: null,

  onEnd: function (e) {
    e.preventDefault()
    
    const file1 = document.getElementById('sidebar-file-1')
    const file2 = document.getElementById('sidebar-file-2')
    const file2link = document.getElementById('lightbox-course-video-link-input-real')

    // verifico presenza file 1
    if (file1 && !file1.value) {
      Flash.warning('Load a file please')
      return
    }

    // veriifico presenza file 2
    if (file2 && (!file2.value && file2link.value == '')) {
      Flash.warning('Load a file please')
      return
    }

    const progressBar = document.querySelector('#courseLoggedSidebarExamProgressbar')
    progressBar.classList.add('is-active')
    const line = progressBar.querySelector('.c-progressbar__line-level')
    
    e.currentTarget.classList.add('loading')
    e.currentTarget.setAttribute('disabled', '')
    
    // submit custom
    var data = new FormData(this.form);
    var request = new XMLHttpRequest();

    request.addEventListener('load', function(e) {
      location.reload()
    })

    request.upload.addEventListener('progress', function(e) {
      const percent = (100 * event.loaded / event.total)
      line.style.width = percent.toFixed(2) + '%'
    })

    request.open('post', this.form.getAttribute('action'))
    request.send(data)
  },

  init: function () {
    this.onEnd = this.onEnd.bind(this)

    if (this.container) {
      this.slider = new Flickity(this.container, {
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        adaptiveHeight: true
      })

      this.slides = this.slider.slides
      this.slider.cells.forEach((slide, i) => {
        const form = slide.element.querySelector('form')
        const submitButton = slide.element.querySelector('.js-sidebar-submit')

        if (form && submitButton) {
          this.form = form
        }
      })

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.slider.previous()
        })
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.slider.next()
        })
      }

      this.slider.on('change', i => {
        this.steps.forEach((step, j) => {
          if (j <= i) {
            step.classList.add('is-active')
          } else {
            step.classList.remove('is-active')
          }
        })

        if (this.nextButton) {
          if (i == this.slider.slides.length - 1) {
            this.nextButton.innerHTML = 'Confirm'
            this.finalListener = this.nextButton.addEventListener('click', this.onEnd)
          } else {
            this.nextButton.innerHTML = 'Next'
            this.nextButton.removeEventListener('click', this.onEnd)
          }
        }
      })
    }
  }
}

export const testimonialSlider = {
  containers: document.querySelectorAll('.js-testimonial-slider-container'),
  instances: [],

  initInstances: function () {
    this.instances.forEach(_ => {
      if (_.prevArrow) {
        _.prevArrow.addEventListener('click', () => {
        _.slider.previous()
        })
      }
      if (_.nextArrow) {
        _.nextArrow.addEventListener('click', () => {
        _.slider.next()
        })
      }
    })
  },

  init: function () {
    if (this.containers.length) {
      this.containers.forEach(container => {
        const el = container.querySelector('.js-testimonial-slider')
        const prevArrow = container.querySelector('.js-testimonial-prev')
        const nextArrow = container.querySelector('.js-testimonial-next')

        if (el) {
          const slider = new Flickity(el, {
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            adaptiveHeight: true
          })

          this.instances.push({
            container,
            el,
            slider,
            prevArrow,
            nextArrow
          })

          this.initInstances()
        } else {
          console.error('Testimonial slider inner element not found')
        }

      })
    }
  }
}


// WEBPACK FOOTER //
// app/javascript/scripts/components/Sliders.js